module.exports = __webpack_public_path__ + "static/media/loading_svg.146fdf41.svg";